import { useEffect } from "react";
import { appConfig } from "@shared/utils/appConfig";
import { useUIStore } from "@store/ui.store";
import { Typography } from "@mui/material";
import { PRODUCTION_SIDEKICK_APP_URL } from "@shared/utils/constants";

export const useStagingWarning = () => {
  const confirmDialog = useUIStore((store) => store.confirmDialog);

  useEffect(() => {
    if (appConfig.APP_ENV !== "staging") return;

    const STAGING_WARNING_STORAGE_KEY = "@sidekick:staging-warning-last-shown";
    const HOURS_TO_WAIT = 7 * 24 * 60 * 60 * 1000;

    const handleFocus = () => {
      const lastShown = localStorage.getItem(STAGING_WARNING_STORAGE_KEY);

      if (lastShown && Date.now() - Number(lastShown) < HOURS_TO_WAIT) return;

      localStorage.setItem(STAGING_WARNING_STORAGE_KEY, String(Date.now()));
      confirmDialog({
        title: "Staging Environment",
        confirmButtonText: "Ok",
        cancelButtonText: false,
        content: (
          <div>
            <Typography gutterBottom>
              You are currently using the <strong>staging environment</strong>.
            </Typography>
            <Typography variant="body2">
              This environment is <strong>not stable</strong> — you may
              encounter:
            </Typography>
            <ul style={{ marginTop: 8, paddingLeft: 20 }}>
              <Typography component="li" variant="body2">
                Unexpected bugs and broken features
              </Typography>
              <Typography component="li" variant="body2">
                Design differences compared to production
              </Typography>
              <Typography component="li" variant="body2">
                Data that does not reflect real production data
              </Typography>
            </ul>
            <Typography variant="body2" sx={{ mt: 2 }}>
              Looking for production?{" "}
              <a
                href={PRODUCTION_SIDEKICK_APP_URL}
                target="_blank"
                rel="noreferrer"
              >
                app.sidekickgpt.io
              </a>
            </Typography>
          </div>
        ),
      });
    };

    handleFocus();
    window.addEventListener("focus", handleFocus);
    return () => window.removeEventListener("focus", handleFocus);
  }, [confirmDialog]);
};
